import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import LoginPage from "@/pages/Auth/Login";
import ResetPasswordPage from "@/pages/Auth/ResetPassword";
import MainRoutes from "./mainRoutes";
import NotFoundPage from "@/pages/NotFound";

import { userIsLoggedIn, userIsNotLoggedIn } from "@/hoc/authWrapper";

const WrappedLoginPage = userIsNotLoggedIn(LoginPage);
const WrappedResetPasswordPage = userIsNotLoggedIn(ResetPasswordPage);
const WrappedMainRoutes = userIsLoggedIn(MainRoutes);

const Routes = () => {
  return (
    <div>
      <Switch>
        <Redirect exact from="/" to="/login" />
        <Route exact path="/login" component={WrappedLoginPage} />
        <Route exact path="/reset/:code" component={WrappedResetPasswordPage} />
        <Route path="/main" component={WrappedMainRoutes} />

        {/* Show Not Found page when url does not match */}
        <Route component={NotFoundPage} />
      </Switch>
    </div>
  );
};

export default Routes;
